import React from 'react'

export default props => (
  <svg
    width="50px"
    height="50px"
    viewBox="0 0 50 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <circle
        id="path-1"
        cx="25"
        cy="25"
        r="25"
      />
    </defs>
    <g id="Pod-mockups---hifi" stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="1---Pod-Management-Pgv2" transform="translate(-95.000000, -368.000000)">
        <g id="Group-4" transform="translate(40.000000, 238.000000)">
          <g id="Group-3" transform="translate(40.000000, 130.000000)">
            <g transform="translate(15.000000, 0.000000)">
              <g>
                <mask id="mask-2" fill="white">
                  <use href="#path-1" />
                </mask>
                <use id="Circle" fill="#CDCDD3" href="#path-1" />
                <path
                  d="M5.81577715,40.6399947 C5.81577715,40.6399947 12.7857561,31.1159707 25.0433052,31.1159707 C37.3008544,31.1159707 44.2708333,40.6399947 44.2708333,40.6399947 L44.1842228,49.4175413 C44.1842228,52.0366479 42.7421582,54.1795533 40.9796348,54.1795533 L8.93375468,54.1795533 C7.17123127,54.1795533 5.72916667,52.0366479 5.72916667,49.4175413 L5.81577715,40.6399947 Z M34.7363937,17.5926685 C34.7363937,22.9342051 30.3745039,27.3045533 25.0433052,27.3045533 C19.7121066,27.3045533 15.3502168,22.9342051 15.3502168,17.5926685 C15.3502168,12.2511319 19.7121066,7.88078371 25.0433052,7.88078371 C30.3745039,7.88078371 34.7363937,12.2511319 34.7363937,17.5926685 Z"
                  fill="#F2F2F4"
                  mask="url(#mask-2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
